import { render, staticRenderFns } from "./List.vue?vue&type=template&id=9838b8c8&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=9838b8c8&prod&scoped=true&lang=css&"
import style1 from "./List.vue?vue&type=style&index=1&id=9838b8c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9838b8c8",
  null
  
)

export default component.exports